module.exports = __webpack_public_path__ + "04c167c0f807f2eae9bacb4dea70d39a.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/india.jpg
// module id = 599
// module chunks = 0